import React, { ReactElement } from 'react';
import { useTranslations } from '../../../../translations';
import {
  CustomersSubscriptionPopup,
  CustomersSubscriptionPopupControls,
  CustomersSubscriptionPopupSubtitle,
  CustomersSubscriptionPopupTitle,
} from '../../customersSubscriptionPopup.styled';
import { useUser } from '../../../../user';
import { useCustomersSubscriptionPopupContext } from '../../customersSubscriptionPopup.context';
import { ButtonColor, ButtonContainer } from '../../../../button';
import {
  getBuySubscriptionHref,
  getCoursesHref,
} from '../../customersSubscriptionPopup.helper';
import { IconErrorComponent } from '../../../../icons';
import { publicConfig } from '../../../../../services';
import { projectTypes } from '../../../../../constants';

export const NotFound = (): ReactElement => {
  const translations = useTranslations();
  const { user } = useUser();
  const { handleClosePopup } = useCustomersSubscriptionPopupContext();

  return (
    <CustomersSubscriptionPopup>
      <IconErrorComponent width={48} height={48} fillColor="#201926" />
      <CustomersSubscriptionPopupTitle>
        {translations.no_active_subscription_by_phone_number.replace(
          '{{PHONE}}',
          user?.personal.phone || ''
        )}
      </CustomersSubscriptionPopupTitle>
      <CustomersSubscriptionPopupSubtitle>
        {translations.you_can_buy_subscription_or_choose_on_catalog}
      </CustomersSubscriptionPopupSubtitle>
      <CustomersSubscriptionPopupControls>
        <ButtonContainer
          fullWidth
          href={getCoursesHref()}
          target={
            publicConfig.APP_TYPE !== projectTypes.courses
              ? '_blank'
              : undefined
          }
          title={translations.courses_catalog}
          color={ButtonColor.transparent}
          borderRadius={100}
          onClick={handleClosePopup}
        />
        <ButtonContainer
          fullWidth
          href={getBuySubscriptionHref()}
          target="_blank"
          title={translations.buy_subscription}
          color={ButtonColor.purple}
          borderRadius={100}
          onClick={handleClosePopup}
        />
      </CustomersSubscriptionPopupControls>
    </CustomersSubscriptionPopup>
  );
};
